import React from "react";
import { FaMoneyCheck } from "react-icons/fa";

export default function Pay(props) {

  return (
    <>
      <div className="icon-button">
        <FaMoneyCheck/>
      </div>
    </>
  );
}
